import React from 'react';
import {
    Card,
    Layout,
    TextStyle,
    Button,
    ResourceItem,
    Stack,
    Modal,
    Thumbnail,
    ResourceList,
} from '@shopify/polaris';
import { Chart } from "react-google-charts";
import { withRouter } from "react-router";
import TagViewComponent from './TagViewComponent';
import FileSaver from 'file-saver';
import { GenieTag } from './GenieTag';
import Cookies from "js-cookie";
import { apiFetch as fetch } from '../common/Helpers';

function renderResourceItem(item) {
    const { id, title, legacyId, image, tags } = item;

    return (
        <ResourceItem id={id} url={null} media={
            <Thumbnail source={image} alt="image" />
        } onClick={(e) => handleProductItemClick(e, legacyId)}>
            <h3 className="previewProductTitle">
                <TextStyle variation="strong">{title}</TextStyle>
            </h3>
            <Stack spacing="tight" distribution="leading" alignment="leading">{getTagList(tags)}</Stack>
        </ResourceItem>
    );
}

function handleProductItemClick(e, id) {
    const shopOrigin = Cookies.get("shopOrigin");
    window.open(`https://${shopOrigin}/admin/products/${id}`, '_blank');
}

function getTagList(tags) {
    return tags.map(item => {

        let state = "default";
        if (item.selected) {
            state = "added";
        }

        return <GenieTag selectable={false} state={state}>{item.tagName}</GenieTag>
    });
}

class DashboardProductsTab extends React.Component {

    state = {
        selectedTag: null,
        taggedResources: []
    };

    render() {

        const tagsReversed = [...this.props.tags].reverse();
        const tagCount = this.props.tags.length;

        var mostCommonTags = [
            [
                'Name',
                'Number of Products',
                { role: 'annotation' }
            ],
            ...this.props.tags.slice(0, 10).map(item => {
                return [item.tagName, item.resourceCount, item.resourceCount]
            })];

        var leastCommonTags = [
            [
                'Name',
                'Number of Products',
                { role: 'annotation' }
            ],
            ...tagsReversed.slice(0, 10).map(item => {
                return [item.tagName, item.resourceCount, item.resourceCount]
            })];

        let modal = null;

        if (this.state.selectedTag != null) {

            let previewItems = this.state.taggedResources.map((item, index) => {
                return {
                    id: index,
                    url: null,
                    title: item.productName,
                    image: item.image,
                    tags: item.tags,
                    legacyId: item.legacyId
                }
            });

            modal = <div>
                <Modal
                    open={true}
                    onClose={this.handleModalClose}
                    title={`${previewItems.length} Products tagged with: ${this.state.selectedTag}`}
                    secondaryActions={[
                        {
                            content: 'Close',
                            onAction: this.handleModalClose,
                        },
                    ]}
                >
                    <Modal.Section>
                        <ResourceList
                            resourceName={{ singular: 'product', plural: 'products' }}
                            items={previewItems}
                            renderItem={renderResourceItem}
                        />
                    </Modal.Section>
                </Modal>
            </div>
        }

        return <Layout>
            {modal}
            <Layout.Section fullWidth>
                <Card sectioned>
                    <div>
                        <p>You store has <TextStyle variation="strong">{this.props.productCount}</TextStyle> products with <TextStyle variation="strong">{tagCount}</TextStyle> unique tags.</p>
                        <br></br>
                        <TagViewComponent
                            selectedTags={this.state.selectedTag != null ? [this.state.selectedTag] : []}
                            tags={this.props.tags}
                            canSelect={true}
                            showOrderByGroups={true}
                            orderByGroups={false}
                            showFilterWithGroups={true}
                            onSelectedChange={this.handleSelectedTagChange} />
                        <Stack spacing="loose">
                            <Button size="slim" primary onClick={this.onEditTags}>Edit Tags</Button>
                            <Button size="slim" onClick={this.onExportTags}>Export Tags</Button>
                            <Button size="slim" onClick={this.onExportTagGroups}>Export Tag Groups</Button>
                        </Stack>
                    </div>
                </Card>
            </Layout.Section>
            <Layout.Section oneHalf>
                <Card title="Most common tags" sectioned>
                    <p>Tags by number of products</p>
                    <div className="chartTest">
                        <Chart
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={mostCommonTags}
                            height={'320px'}
                            options={{
                                legend: { position: 'none' },
                                chartArea: { top: 0, right: 0, bottom: 0 },
                            }}
                            rootProps={{ 'data-testid': '6' }}
                        />
                    </div>
                    <br></br>
                </Card>
            </Layout.Section>
            <Layout.Section oneHalf>
                <Card title="Least common tags" sectioned>
                    <p>Tags by number of products</p>
                    <div className="chartTest">
                        <Chart
                            chartType="BarChart"
                            loader={<div>Loading Chart</div>}
                            data={leastCommonTags}
                            height={'320px'}
                            // width={'400px'}
                            options={{
                                legend: { position: 'none' },
                                chartArea: { top: 0, right: 0, bottom: 0 },
                            }}
                            // For tests
                            rootProps={{ 'data-testid': '6' }}
                        />
                    </div>
                    <br></br>
                </Card>
            </Layout.Section>
        </Layout>
    }

    handleModalClose = () => {
        this.setState({ "selectedTag": null });
    }

    handleSelectedTagChange = (selectedTags) => {

        if (selectedTags.length <= 0) {
            return;
        }

        this.setState({ "selectedTag": selectedTags[0] });
        this.fetchTaggedResources(selectedTags[0]);
    }

    fetchTaggedResources = (tag) => {
        fetch(`api/dashboard/tagProducts?tagName=${encodeURIComponent(tag)}`, {
            method: 'GET'
        }).then(response => {
            return response.json()
        }).then(data => this.setState({
            taggedResources: data.products,
            isLoading: false
        }));
    }

    onEditTags = () => {
        this.props.onCreateNewOperation();
    }

    onExportTags = () => {
        let fileBlob = this.createCsv();
        FileSaver.saveAs(fileBlob, "tags.csv");
    }

    onExportTagGroups = () => {
        let fileBlob = this.createCsvTagGroups();
        FileSaver.saveAs(fileBlob, "tag-groups.csv");
    }

    createCsv = () => {
        let csv = ''
        let row = ''
        let headers = ''
        headers = headers.concat('tag_name');
        csv = csv.concat(headers);
        this.props.tags.map(_ => _.tagName).sort().forEach(tag => {
            row = ''
            row = row.concat("\n", tag);
            csv = csv.concat(row)
        });

        return new Blob([csv], { type: 'application/csv;charset=utf-8' })
    }

    createCsvTagGroups = () => {
        let csv = ''
        let rows = ''
        let headers = ''
        headers = headers.concat('Group Name,Tags', "\n");
        const tagGroups = this.props.tags.reduce((accumulator, item) => {
            const key = item["tagGroupName"];
            if (!accumulator[key]) {
                accumulator[key] = [];
            }
            // Add object to list for given key's value
            accumulator[key].push(item.tagName);
            return accumulator;
        }, {});

        var groupNames = Object.getOwnPropertyNames(tagGroups);
        csv = csv.concat(headers);
        groupNames.forEach(group => {
            var items = tagGroups[group];
            rows = items.map(_ => group + "," + _);
            csv = csv + rows.join("\n") + "\n";
        });

        return new Blob([csv], { type: 'application/csv;charset=utf-8' })
    }
}

export default withRouter(DashboardProductsTab);